import {
  C_OveraskDataBetPlacement,
  CloseTicketItem,
  CloseTicketResult,
  CombinationMulticastInput,
  LineItem,
  OddItem,
  RaceLineItem,
  SmartLineItem,
  SmartMarketInput,
  StraightMulticastInput,
  newOveraskData,
  oddsUpdateItem,
} from "@ticket/models";

import { AABonusMethods } from "@sports-utils/index";
import * as TicketMethods from "@sports-utils/ticket-apuestas-methods.utils";

import {
  BetslipFilterItem,
  C_FreeBetTicket,
  StakeGroup,
  StakeModel,
  TicketBetslipModel,
  _getFilters,
  systemData,
  ticketState,
} from "../models";

import { createReducer, on } from "@ngrx/store";
import { BetslipProviderModel } from "../models/betslip-provider.model";
import * as FreebetHelpers from "../utils/freebet-helpers.utils";
import {
  BetslipItemTypesEnum,
  SingleStakeLimits,
  SystemStakeLimits,
  TicketItemTypesEnum,
  ticketErrorConstants,
} from "../utils/ticket.constants";
import * as actions from "./ticket.actions";

const initialState: ticketState = {
  betSlip: null,
  filters: _getFilters(),
  filterSelected: null,
  freeBets: [],
  betbuilderSelection: [],
  processingFrom: "",
  processingItem: null,
  ticket: TicketMethods.newC_TicketApuestas(),
};

const aux = {
  keepSelection: false,
  modification: false,
  setToAccumulator: false,
  valueCombinationMulticast: undefined,
  valueLineItems: undefined,
  valueSmartLineItems: undefined,
  valueStraightM: undefined,
};

export const ticketReducer = createReducer(
  initialState,
  on(actions.AddCombinationMulticast, (state, action) =>
    addCombinationMulticast(state, action.combinationMulticastInput, action.combinationMulticastItem),
  ),
  on(actions.AddSingleResult, (state, action) => addSingleResult(state, action.game)),
  on(actions.AddSingleResultById, (state, action) => addSingleResultById(state, action.betId)),
  on(actions.AddSmartMarketItem, (state, action) =>
    addSmartMarketItem(state, action.smartMarketRequest, action.smartMarketBet),
  ),
  on(actions.AddSmartMarketSelection, (state, action) => addSmartMarketSelection(state, action.selection)),
  on(actions.AddStraightMulticast, (state, action) =>
    addStraightMulticast(state, action.straightMulticastInput, action.straightMulticastItem),
  ),
  on(actions.AmountLocalLineItemUpdate, (state, action) =>
    amountLocalLineItemUpdate(state, action.selectedLine, action.value),
  ),
  on(actions.AmountLocalTotalUpdate, (state, action) => amountLocalTotalUpdate(state, action.value)),
  on(actions.BetbuilderOddsChange, (state) => betbuilderOddsChange(state)),
  on(actions.ChangeFilter, (state, action) => changeFilter(state, action.filter)),
  on(actions.ChangeFilterAndSetOddErrors, (state, action) => changeFiltersAndSetOddErrors(state, action.filter)),
  on(actions.CheckForErrors, (state) => checkForErrors(state)),
  on(actions.CloseBet, (state, _action) => closeBet(state)),
  on(actions.ClosedTicketResult, (state, action) =>
    closedTicketResult(state, action.closeTicketResult, action.newOdds),
  ),
  on(actions.CloseTicketResultAndOddsUpdate, (state, action) =>
    closedTicketResult(state, action.closeTicketResult, action.newOdds),
  ),
  on(actions.FreeBetsAdd, (state, action) =>
    freeBetsAdd(state, action.voucher, action.personalized, action.filterSelected),
  ),
  on(actions.FreeBetsCancel, (state, action) => freeBetsCancel(state, action.voucherCode)),
  on(actions.FreeBetsSetVouchers, (state, action) => freeBetsSetVouchers(state, action.vouchers)),
  on(actions.FreeBetsUpdateValidations, (state, action) =>
    freeBetsUpdateValidations(state, action.freebetStake, action.betSlip),
  ),
  on(actions.FreeBetsUpdateVouchers, (state) => freeBetsUpdateVouchers(state)),
  on(actions.InitFilters, (state, action) => initFilters(state, action.filters)),
  on(actions.KeepSelection, (state, action) => keepSelection(state, action.cuotaAccept, action.userLogged)),
  on(actions.MarketLocked, (state, action) => marketLocked(state, action.odds)),
  on(actions.OveraskMaxStake, (state, action) =>
    overaskMaxStake(state, action.overaskData, action.status, action.stake),
  ),
  on(actions.OveraskRejected, (state, action) => overaskRejected(state, action.overaskData, action.status)),
  on(actions.OveraskStart, (state, action) => overaskStart(state, action.overaskData, action.closeBetStake)),
  on(actions.OveraskStartPolling, (state, action) =>
    overaskStartPolling(state, action.overaskData, action.status),
  ),
  on(actions.OveraskTimeout, (state, action) => overaskTimeout(state, action.overaskData, action.status)),
  on(actions.PlaceBet, (state, action) => placeBet(state, action.groupKey)),
  on(actions.RecoverTicket, (state, action) =>
    recoverTicket(state, action.localStorageBetSlip, action.ticketItemsAndAmount),
  ),
  on(actions.RemoveItem, (state, action) => removeItem(state, action.id, action.itemType)),
  on(actions.RemoveItems, (state, action) => removeItems(state, action.ids)),
  on(actions.RemoveSmartMarketAllSelections, (state) => removeSmartMarketAllSelections(state)),
  on(actions.RemoveSmartMarketSelection, (state, action) => removeSmartMarketSelection(state, action.id)),
  on(actions.RemoveTicket, (state) => removeTicket(state)),
  on(actions.SaveBetSlip, (state, action) => saveBetSlip(state, action.betSlip)),
  on(actions.SaveBetSlipAndEvaluateFlow, (state, action) =>
    saveBetSlipAndEvaluateFlow(state, action.betSlip, action.checkFilterChange),
  ),
  on(actions.SetBetOddAcceptance, (state) => setOddErrors(state)),
  on(actions.SetFilters, (state) => setFilters(state)),
  on(actions.SetFilterSelected, (state) => setFilterSelected(state)),
  on(actions.SetLineItemSelected, (state, action) => setLineItemSelected(state, action.lineItemSelection)),
  on(actions.SetLineItemUnselected, (state) => setLineItemUnselected(state)),
  on(actions.SetMultiStake, (state, action) => setMultiStake(state, action.multiStake)),
  on(actions.SetOddErrors, (state) => setOddErrors(state)),
  on(actions.SetStake, (state, action) => setStake(state, action.stake)),
  on(actions.SetSystemBetType, (state, action) =>
    setSystemBetType(state, action.newTicketState, action.systemStake),
  ),
  on(actions.TicketError, (state, action) => ticketError(state, action.error)),
  on(actions.UpdateAndChangeToSingles, (state, action) =>
    updateAndChangeToSingles(state, action.cuotaAccept, action.userLogged),
  ),
  on(actions.UpdateAndCheckForErrors, (state, action) =>
    updateAndCheckForErrors(state, action.cuotaAccept, action.userLogged),
  ),
  on(actions.UpdateTicket, (state, action) => updateTicket(state, action.cuotaAccept, action.userLogged)),
);

const addCombinationMulticast = (
  state: ticketState,
  _combinationMulticastInput: CombinationMulticastInput,
  combinationMulticastItem: RaceLineItem,
): ticketState => {
  const auxStateTicket = { ...state.ticket, processing: true } as TicketBetslipModel;
  const combinationMulticastItems = [...auxStateTicket.CombinationMulticast, combinationMulticastItem];

  aux.modification = true;
  aux.valueCombinationMulticast = combinationMulticastItems;

  return {
    ...state,
    processingFrom: "addCombinationMulticast",
    ticket: auxStateTicket,
  };
};

const addSingleResult = (state: ticketState, game: LineItem): ticketState => {
  aux.modification = true;
  aux.valueLineItems = [...state.ticket.LineItems, LineItem.mapItem(game)];
  return {
    ...state,
    processingFrom: "addSingleResult",
    ticket: {
      ...state.ticket,
      LineItems: [...state.ticket.LineItems, LineItem.mapItem(game)],
    },
  };
};

const addSingleResultById = (state: ticketState, _betId: number): ticketState => {
  const auxStateTicket = { ...state.ticket, processing: true } as TicketBetslipModel;

  return {
    ...state,
    processingFrom: "addSingleResultById",
    ticket: auxStateTicket,
  };
};

const addSmartMarketItem = (
  state: ticketState,
  _smartMarketRequest: SmartMarketInput,
  smartMarketBet: SmartLineItem,
): ticketState => {
  const auxState = { ...state, ticket: { ...state.ticket, processing: true } };
  const updatedSmartLineItems = [...auxState.ticket.SmartLineItems, smartMarketBet];

  aux.modification = true;
  aux.valueSmartLineItems = updatedSmartLineItems;

  return {
    ...auxState,
    betbuilderSelection: [],
    processingFrom: "addSmartMarketItem",
    ticket: {
      ...auxState.ticket,
      SmartLineItems: updatedSmartLineItems,
    },
  };
};

const addSmartMarketSelection = (state: ticketState, selection: LineItem): ticketState => {
  const updatedBetbuilderSelection = [...state.betbuilderSelection, selection];

  return {
    ...state,
    betbuilderSelection: updatedBetbuilderSelection,
  };
};

const addStraightMulticast = (
  state: ticketState,
  _straightMulticastInput: StraightMulticastInput,
  straightMulticastItem: RaceLineItem,
): ticketState => {
  const auxStateTicket = { ...state.ticket, processing: true } as TicketBetslipModel;
  const straightMulticastItems = [...auxStateTicket.StraightM, straightMulticastItem];

  aux.modification = true;
  aux.valueStraightM = straightMulticastItems;

  return {
    ...state,
    processingFrom: "addStraightMulticast",
    ticket: {
      ...auxStateTicket,
      StraightM: straightMulticastItems,
    },
  };
};

const amountLocalLineItemUpdate = (state: ticketState, selectedLine, value): ticketState => {
  const auxStateTicket = { ...state.ticket } as TicketBetslipModel;

  const updateAmountLocal = (line) => ({
    ...line,
    AmountLocal:
      line.ItemId === selectedLine.ItemId && line.ResultsNr === selectedLine.ResultsNr ? value : line.Amount,
  });

  auxStateTicket.LineItems = auxStateTicket.LineItems.map(updateAmountLocal);
  auxStateTicket.StraightM = auxStateTicket.StraightM.map(updateAmountLocal);
  auxStateTicket.CombinationMulticast = auxStateTicket.CombinationMulticast.map(updateAmountLocal);

  auxStateTicket.SmartLineItems = auxStateTicket.SmartLineItems.map((line) => ({
    ...line,
    AmountLocal: line.ItemId === selectedLine.ItemId ? value : line.Amount,
  }));

  auxStateTicket.TotalLocal = [...auxStateTicket.LineItems, ...auxStateTicket.SmartLineItems]
    .reduce((total, item) => total + +item.AmountLocal, 0)
    .toString();

  return {
    ...state,
    processingFrom: "",
    ticket: auxStateTicket,
  };
};

const amountLocalTotalUpdate = (state: ticketState, value: number): ticketState => {
  const auxStateTicket = { ...state.ticket } as TicketBetslipModel;

  const updateAmountLocal = (line) => ({
    ...line,
    AmountLocal: value,
  });

  auxStateTicket.LineItems = [...auxStateTicket.LineItems.map(updateAmountLocal)];
  auxStateTicket.SmartLineItems = [...auxStateTicket.SmartLineItems.map(updateAmountLocal)];
  auxStateTicket.StraightM = [...auxStateTicket.StraightM.map(updateAmountLocal)];
  auxStateTicket.CombinationMulticast = [...auxStateTicket.CombinationMulticast.map(updateAmountLocal)];

  auxStateTicket.TotalLocal = value.toString();

  return {
    ...state,
    ticket: auxStateTicket,
  };
};

const betbuilderOddsChange = (state: ticketState): ticketState => {
  return {
    ...state,
    ticket: { ...state.ticket, hasChangesInOdds: true },
  };
};

const changeFilter = (state: ticketState, value: number): ticketState => {
  const auxStateFilters = state.filters.map((filter, index) => ({
    ...filter,
    selected: value === index,
  }));

  const auxStateFilterSelected = auxStateFilters[value];
  let auxStateTicket: TicketBetslipModel = {
    ...state.ticket,
    BetType: value,
    TotalPotentialWin: state.ticket.StakeGroups[auxStateFilterSelected.betType]?.totalPotentialWin || 0,
    Total: state.ticket.StakeGroups[auxStateFilterSelected.betType]?.totalAmount || 0,
    TotalLocal: (state.ticket.StakeGroups[auxStateFilterSelected.betType]?.totalAmount || 0).toString(),
  };

  if (aux.setToAccumulator) {
    auxStateTicket = _ticketCheckErrors({ ...state, ticket: auxStateTicket });
    aux.setToAccumulator = false;
  }

  return {
    ...state,
    filters: auxStateFilters,
    filterSelected: auxStateFilterSelected,
    ticket: auxStateTicket,
  };
};

const changeFiltersAndSetOddErrors = (state: ticketState, value: number): ticketState => {
  const auxState = { ...state };

  auxState.filters = auxState.filters.map((filter, index) => ({
    ...filter,
    selected: value === index,
  }));

  auxState.filterSelected = auxState.filters[value];
  auxState.ticket = {
    ...auxState.ticket,
    BetType: value,
    TotalPotentialWin: auxState.ticket.StakeGroups[auxState.filterSelected.betType]?.totalPotentialWin || 0,
    Total: auxState.ticket.StakeGroups[auxState.filterSelected.betType]?.totalAmount || 0,
    TotalLocal: (auxState.ticket.StakeGroups[auxState.filterSelected.betType]?.totalAmount || 0).toString(),
  };

  return setOddErrors(auxState);
};

const checkForErrors = (state: ticketState): ticketState => {
  const auxStateTicket = _ticketCheckErrors(state);
  return {
    ...state,
    ticket: auxStateTicket as TicketBetslipModel,
  };
};

const closeBet = (state: ticketState): ticketState => {
  const updatedTicket = {
    ...state.ticket,
    processing: true,
    OveraskInfo: newOveraskData(),
  };

  return {
    ...state,
    processingFrom: "closeBet",
    ticket: updatedTicket,
  };
};

const closedTicketResult = (
  state: ticketState,
  closeTicketResult: CloseTicketResult,
  _newOdd: OddItem[],
): ticketState => {
  let auxStateTicket = { ...state.ticket, processing: true } as TicketBetslipModel;

  const updateLineItems = (items, ticketItems) => {
    return items.map((item) => {
      const matchedItem = ticketItems.find((ticketItem) => ticketItem.ItemId === item.ItemId);
      if (matchedItem) {
        return {
          ...item,
          TicketNumber: matchedItem.TicketId,
          LineErrors: matchedItem.ErrorDescription,
          LineErrorMessages: matchedItem.ErrorCode
            ? [...(item.LineErrorMessages || []), matchedItem.ErrorDescription]
            : item.LineErrorMessages,
          TotalPotentialWin: matchedItem.PotentialWin || 0,
          Amount: matchedItem.Stake / 100,
          upOdd: false,
          downOdd: false,
        };
      }
      return { ...item, upOdd: false, downOdd: false };
    });
  };

  if (closeTicketResult.TicketItems) {
    auxStateTicket.LineItems = updateLineItems(auxStateTicket.LineItems, closeTicketResult.TicketItems);
    auxStateTicket.SmartLineItems = updateLineItems(auxStateTicket.SmartLineItems, closeTicketResult.TicketItems);
    auxStateTicket.StraightM = updateLineItems(auxStateTicket.StraightM, closeTicketResult.TicketItems);
    auxStateTicket.CombinationMulticast = updateLineItems(
      auxStateTicket.CombinationMulticast,
      closeTicketResult.TicketItems,
    );
  } else if (closeTicketResult.SingleTicketItem) {
    const singleTicket = closeTicketResult.SingleTicketItem;
    auxStateTicket.TicketNumber = singleTicket.TicketId;
    if (singleTicket.ErrorCode) {
      // auxStateTicket.OrderErrors[singleTicket.ErrorCode] = singleTicket.ErrorDescription;
      const orderErrors = {
        OrderErrors: { [singleTicket.ErrorCode]: singleTicket.ErrorDescription },
        OrderErrorMessages: [...auxStateTicket.OrderErrorMessages, singleTicket.ErrorDescription],
      };
      auxStateTicket = { ...auxStateTicket, ...orderErrors };
      auxStateTicket = _checkOddsChangeErrors(auxStateTicket, singleTicket.ErrorCode);
      auxStateTicket = _checkSmartLineItemMarketErrors(auxStateTicket, singleTicket);
    }
    if (singleTicket.NewOdds) {
      const updateOdds = (items) => closeBetNewOds(items, singleTicket.NewOdds);
      auxStateTicket.LineItems = updateOdds(auxStateTicket.LineItems);
      auxStateTicket.SmartLineItems = updateOdds(auxStateTicket.SmartLineItems);
      auxStateTicket.StraightM = updateOdds(auxStateTicket.StraightM);
      auxStateTicket.CombinationMulticast = updateOdds(auxStateTicket.CombinationMulticast);
    }
  } else if (closeTicketResult.PlayerError) {
    const orderErrors = {
      OrderErrors: { [ticketErrorConstants.code_9999999.code]: closeTicketResult?.PlayerErrorMessage },
      OrderErrorMessages: [...auxStateTicket.OrderErrorMessages, closeTicketResult?.PlayerErrorMessage],
    };
    auxStateTicket = { ...auxStateTicket, ...orderErrors };
  }

  auxStateTicket.TotalLocal = (closeTicketResult.TotalStake / 100).toString();
  auxStateTicket.TotalPotentialWin = closeTicketResult.TotalPotentialWin / 100;
  auxStateTicket.processing = false;
  auxStateTicket.keepSelection = false;

  return {
    ...state,
    processingFrom: "",
    ticket: auxStateTicket,
  };
};

const freeBetsAdd = (state: ticketState, _voucher, _personalized, _filterSelected): ticketState => state;

const freeBetsCancel = (state: ticketState, _voucherCode: string): ticketState => {
  return {
    ...state,
    ticket: { ...state.ticket, FreeBetVoucherId: null, FreebetInstance: null },
  };
};

const freeBetsSetVouchers = (state: ticketState, vouchers: C_FreeBetTicket[]): ticketState => {
  return {
    ...state,
    freeBets: vouchers,
  };
};

const freeBetsUpdateValidations = (
  state: ticketState,
  _freebetStake: StakeModel,
  betSlip: BetslipProviderModel,
): ticketState => {
  const auxStateTicket = { ...state.ticket };
  const auxStateFreeBets = [...state.freeBets];

  if (betSlip.bonus.freeBetVouchers.length > 0) {
    if (TicketMethods.getNumberOfSelections(auxStateTicket) < 1) {
      auxStateTicket.FreeBetVoucherId = "";
      auxStateTicket.FreebetInstance = FreebetHelpers.newFreebetInstance();
    } else {
      const FBVoucher = auxStateFreeBets.find(
        (i) => i.VoucherCode === betSlip.bonus.freeBetVouchers[0].voucherCode,
      );
      if (FBVoucher) {
        auxStateTicket.FreeBetVoucherId = FBVoucher.VoucherCode;
        auxStateTicket.FreebetInstance = FreebetHelpers.mapFreebetInstance(FBVoucher, betSlip.bonus);
      }
    }
  }

  return {
    ...state,
    ticket: auxStateTicket,
  };
};

const freeBetsUpdateVouchers = (state: ticketState): ticketState => state;

const initFilters = (state: ticketState, filters: BetslipFilterItem[]): ticketState => {
  sessionStorage.removeItem("licenseType");

  const auxFilters = state.filters ? state.filters : filters;
  const auxFilterSelected = auxFilters.find((i) => i.selected) || filters[0];

  const auxStateTicket = {
    ...state.ticket,
    BetType: auxFilterSelected.value,
    processing: false,
  } as TicketBetslipModel;

  return {
    ...state,
    filters: auxFilters,
    filterSelected: auxFilterSelected,
    ticket: auxStateTicket,
  };
};

const keepSelection = (state: ticketState, _cuotaAccept: string, _userLogged: boolean): ticketState => {
  const auxStateTicket = {
    ...state.ticket,
    TicketNumber: null,
    OveraskInfo: newOveraskData(),
    keepSelection: true,
  };
  return {
    ...state,
    ticket: auxStateTicket,
  };
};

const marketLocked = (state: ticketState, odd: oddsUpdateItem[]): ticketState => {
  const auxStateTicket = { ...state.ticket } as TicketBetslipModel;

  const updateLineItems = (lineItems, odd) => {
    return lineItems.map((lineItem) => {
      const existItemId = odd.find((item) => item.NodeId === lineItem.ResultsNr);
      if (existItemId) {
        return {
          ...lineItem,
          GameLocked: existItemId.Locked,
          NotAvailable: existItemId.NotAvailable,
          upOdd: !existItemId.Locked && lineItem.Odd < existItemId.Odd,
          downOdd: !existItemId.Locked && lineItem.Odd > existItemId.Odd,
        };
      }
      return { ...lineItem, upOdd: false, downOdd: false };
    });
  };

  auxStateTicket.LineItems = updateLineItems(auxStateTicket.LineItems, odd);
  auxStateTicket.SmartLineItems = updateLineItems(auxStateTicket.SmartLineItems, odd);
  auxStateTicket.StraightM = updateLineItems(auxStateTicket.StraightM, odd);
  auxStateTicket.CombinationMulticast = updateLineItems(auxStateTicket.CombinationMulticast, odd);

  const newAuxStateTicket = _ticketCheckErrors({ ...state, ticket: auxStateTicket });

  return {
    ...state,
    ticket: newAuxStateTicket,
  };
};

const overaskMaxStake = (state: ticketState, overaskData, status: number | string = 1, _stake): ticketState => {
  const auxStateTicket = { ...state.ticket, processing: true } as TicketBetslipModel;
  auxStateTicket.OveraskInfo = {
    ExpiryDate: "",
    MaxStake: overaskData.MaxStake / 100,
    RejectId: overaskData.OveraskRejectId,
    Status: status,
    StatusString: "Max Stake",
  };

  return { ...state, processingFrom: "overaskMaxStake", ticket: auxStateTicket };
};

const overaskRejected = (state: ticketState, overaskData: C_OveraskDataBetPlacement, status = 3): ticketState => {
  const auxStateTicket = { ...state.ticket, processing: false } as TicketBetslipModel;
  auxStateTicket.OveraskInfo = {
    ExpiryDate: "",
    MaxStake: 0,
    RejectId: overaskData.RejectId,
    Status: status,
    StatusString: "Rejected",
  };

  return { ...state, processingFrom: "", ticket: auxStateTicket };
};

const overaskStart = (state: ticketState, singleTicketItem, closeBetStake): ticketState => {
  const auxStateTicket = { ...state.ticket, processing: true } as TicketBetslipModel;

  auxStateTicket.OveraskInfo = {
    ExpiryDate: "",
    MaxStake: singleTicketItem.PotentialWin,
    RejectId: singleTicketItem.OveraskRejectId,
    Status: 0,
    StatusString: "Pending",
  };
  auxStateTicket.OveraskCloseBet = closeBetStake;

  return { ...state, processingFrom: "overaskStart", ticket: auxStateTicket };
};

const overaskStartPolling = (state: ticketState, overaskInfo, status): ticketState => {
  const auxStateTicket = { ...state.ticket, processing: true } as TicketBetslipModel;

  auxStateTicket.OveraskInfo = {
    ExpiryDate: "",
    MaxStake: overaskInfo.MaxStake / 100,
    RejectId: overaskInfo.RejectId,
    Status: status,
    StatusString: "Pending",
  };

  return { ...state, processingFrom: "overaskStartPolling", ticket: auxStateTicket };
};

const overaskTimeout = (state: ticketState, overaskData, _status = 2): ticketState => {
  const auxStateTicket = { ...state.ticket, processing: false } as TicketBetslipModel;

  auxStateTicket.OveraskInfo = {
    ExpiryDate: "",
    MaxStake: 0,
    RejectId: overaskData.OveraskRejectId,
    Status: 2,
    StatusString: "TimeOut",
  };

  return { ...state, processingFrom: "", ticket: auxStateTicket };
};

const placeBet = (state: ticketState, _placeB): ticketState => {
  return {
    ...state,
    processingFrom: "placeBet",
    ticket: { ...state.ticket, processing: true } as TicketBetslipModel,
  };
};

const recoverTicket = (
  state: ticketState,
  localStorageBetSlip: ticketState,
  _ticketItemsAndAmount: any,
): ticketState => {
  const auxState = {
    ...setFilterSelected(setFilters({ ...localStorageBetSlip })),
    ticket: TicketMethods.parse(localStorageBetSlip.ticket),
  };

  return {
    ...state,
    ticket: auxState.ticket,
    filters: auxState.filters,
    filterSelected: auxState.filterSelected,
  };
};

const removeItem = (state: ticketState, id: number, itemType: TicketItemTypesEnum): ticketState => {
  const auxState = { ...state };
  const auxStateTicket = { ...state.ticket } as TicketBetslipModel;
  auxStateTicket.processing = true;

  let betSlipItemType = BetslipItemTypesEnum.LINE_ITEM;

  switch (itemType) {
    case TicketItemTypesEnum.STRAIGHT:
      betSlipItemType = BetslipItemTypesEnum.STRAIGHT;
      break;
    case TicketItemTypesEnum.COMBINATION:
      betSlipItemType = BetslipItemTypesEnum.COMBINATION;
      break;
    case TicketItemTypesEnum.SMARTMARKET:
      betSlipItemType = BetslipItemTypesEnum.SMARTMARKET;
      break;
    case TicketItemTypesEnum.LINE_ITEM:
    default:
      betSlipItemType = BetslipItemTypesEnum.LINE_ITEM;
      break;
  }

  const item = auxState.betSlip?.items?.[betSlipItemType]?.find((e) => e.itemId === id);
  if (!item) {
    return {
      ...state,
      processingFrom: "removeItem",
      ticket: auxStateTicket,
    };
  }

  aux.modification = true;
  const auxValue = `value${itemType}`;
  aux[auxValue] = auxStateTicket[itemType].filter((i) => i.ItemId !== item.itemId);

  return {
    ...state,
    processingFrom: "removeItem",
    ticket: auxStateTicket,
  };
};

const removeItems = (state: ticketState, ids: number[]): ticketState => {
  const auxStateTicket = { ...state.ticket, processing: true } as TicketBetslipModel;
  const filterItems = (items) => items.filter((item) => !ids.includes(item.ItemId));

  aux.modification = true;
  aux.valueCombinationMulticast = filterItems(auxStateTicket.CombinationMulticast);
  aux.valueStraightM = filterItems(auxStateTicket.StraightM);
  aux.valueSmartLineItems = filterItems(auxStateTicket.SmartLineItems);
  aux.valueLineItems = filterItems(auxStateTicket.LineItems);

  return setOddErrors({
    ...state,
    processingFrom: "removeItems",
    ticket: auxStateTicket,
  });
};

const removeSmartMarketAllSelections = (state: ticketState): ticketState => {
  return { ...state, betbuilderSelection: [] };
};

const removeSmartMarketSelection = (state: ticketState, id: number): ticketState => {
  return {
    ...state,
    processingFrom: "removeSmartMarketSelection",
    betbuilderSelection: state.betbuilderSelection.filter((i) => i.NodeId !== id),
  };
};

const removeTicket = (state: ticketState): ticketState => {
  return {
    ...state,
    processingFrom: "",
    ticket: TicketMethods.newC_TicketApuestas(),
  };
};

const saveBetSlip = (state: ticketState, betSlip: BetslipProviderModel): ticketState => {
  const auxState = { ...state, betSlip };
  let auxStateTicket = { ...auxState.ticket } as TicketBetslipModel;

  const updateItems = (items, betSlipItems, valueItems) => {
    if (valueItems) {
      auxStateTicket[items] = [...valueItems];
      if (betSlipItems.length > 0) {
        const lastItemId = betSlipItems[betSlipItems.length - 1].itemId;
        auxStateTicket[items] = auxStateTicket[items].map((item) =>
          !item.ItemId ? { ...item, ItemId: lastItemId } : item,
        );
      }
    }
  };

  if (aux.modification) {
    updateItems(
      TicketItemTypesEnum.COMBINATION,
      betSlip.items.combinationMulticastItems,
      aux.valueCombinationMulticast,
    );
    updateItems(TicketItemTypesEnum.LINE_ITEM, betSlip.items.singleResultItems, aux.valueLineItems);
    updateItems(TicketItemTypesEnum.SMARTMARKET, betSlip.items.smartMarketItems, aux.valueSmartLineItems);
    updateItems(TicketItemTypesEnum.STRAIGHT, betSlip.items.straightMulticastItems, aux.valueStraightM);

    aux.valueCombinationMulticast = undefined;
    aux.valueStraightM = undefined;
    aux.valueSmartLineItems = undefined;
    aux.valueLineItems = undefined;
    aux.modification = false;
  }

  const auxStakeGroups = {
    ...auxStateTicket.StakeGroups,
    Accumulator: {
      ...auxStateTicket.StakeGroups.Accumulator,
      systemId:
        auxState.betSlip.possibleSystems.find((system) => system.systemType === StakeGroup.ACCUMULATOR)
          ?.systemId || null,
    },
    System: {
      ...auxStateTicket.StakeGroups.System,
      possibleSystems: _setPossibleSystems(auxState.betSlip) || [],
    },
  };

  auxStateTicket = {
    ...auxStateTicket,
    StakeGroups: auxStakeGroups,
    SingleStakeLimits: SingleStakeLimits,
    SystemStakeLimits: SystemStakeLimits,
  };

  if (betSlip.bonus.freeBetVouchers.length > 0) {
    if (TicketMethods.getNumberOfSelections(auxStateTicket) < 1) {
      auxStateTicket = {
        ...auxStateTicket,
        FreeBetVoucherId: "",
        FreebetInstance: FreebetHelpers.newFreebetInstance(),
      };
    } else {
      const FBVoucher = auxState.freeBets.find(
        (i) => i.VoucherCode === betSlip.bonus.freeBetVouchers[0].voucherCode,
      );
      if (FBVoucher) {
        auxStateTicket = {
          ...auxStateTicket,
          FreeBetVoucherId: FBVoucher.VoucherCode,
          FreebetInstance: FreebetHelpers.mapFreebetInstance(FBVoucher, betSlip.bonus),
        };
      }
    }
  }

  const newAuxState: ticketState = {
    ...state,
    betSlip: auxState.betSlip,
    ticket: auxStateTicket as TicketBetslipModel,
  };

  const newAuxStateTemp = setLineItemUnselected(newAuxState);

  return {
    ...state,
    betSlip: newAuxStateTemp.betSlip,
    ticket: newAuxStateTemp.ticket as TicketBetslipModel,
  };
};

const saveBetSlipAndEvaluateFlow = (
  state: ticketState,
  betSlip: BetslipProviderModel,
  _checkFilterChange: boolean,
): ticketState => {
  const auxState = saveBetSlip({ ...state, ticket: { ...state.ticket, processing: true } }, betSlip);

  return {
    ...state,
    processingFrom: "",
    betSlip: auxState.betSlip,
    ticket: auxState.ticket,
  };
};

const setOddErrors = (state: ticketState): ticketState => {
  return {
    ...state,
    ticket: {
      ...state.ticket,
      OrderErrorMessages: [],
      OrderErrors: {},
      hasChangesInOdds: false,
      processing: false,
    },
  };
};

const setFilters = (state: ticketState): ticketState => {
  const updatedFilters = _setFilterStatus(state);
  const auxState = checkForErrors(updatedFilters);

  return {
    ...state,
    filters: auxState.filters,
    filterSelected: auxState.filterSelected,
    ticket: auxState.ticket as TicketBetslipModel,
  };
};

const setFilterSelected = (state: ticketState): ticketState => {
  const auxStateTicket = { ...state.ticket } as TicketBetslipModel;
  const auxFilterSelected = { ...state.filterSelected } as BetslipFilterItem;

  if (
    auxFilterSelected !== undefined &&
    auxFilterSelected !== null &&
    auxStateTicket.StakeGroups[auxFilterSelected.betType]
  ) {
    const group = auxStateTicket.StakeGroups[auxFilterSelected.betType];
    if (group.totalPotentialWin !== undefined && group.totalPotentialWin !== null)
      auxStateTicket.TotalPotentialWin = group.totalPotentialWin;
    if (group.totalAmount !== undefined && group.totalAmount !== null) auxStateTicket.Total = group.totalAmount;
  }

  auxStateTicket.TotalLocal = (auxStateTicket.Total ?? 0).toString();
  auxStateTicket.processing = false;

  return {
    ...state,
    filterSelected: auxFilterSelected,
    processingFrom: "",
    ticket: auxStateTicket,
  };
};

const setLineItemSelected = (
  state: ticketState,
  lineItemSelection: LineItem | SmartLineItem | RaceLineItem,
): ticketState => {
  const auxStateTicket = { ...state.ticket } as TicketBetslipModel;

  const selectLineItems = (lineItems) =>
    lineItems.map((line) => ({ ...line, Selected: line.ItemId === lineItemSelection.ItemId }));

  auxStateTicket.LineItems = selectLineItems(auxStateTicket.LineItems);
  auxStateTicket.StraightM = selectLineItems(auxStateTicket.StraightM);
  auxStateTicket.CombinationMulticast = selectLineItems(auxStateTicket.CombinationMulticast);
  auxStateTicket.SmartLineItems = selectLineItems(auxStateTicket.SmartLineItems);

  return {
    ...state,
    ticket: auxStateTicket,
  };
};

const setLineItemUnselected = (state: ticketState): ticketState => {
  const auxStateTicket = { ...state.ticket } as TicketBetslipModel;
  const unselectLineItems = (lineItems) => lineItems.map((line) => ({ ...line, Selected: false }));

  auxStateTicket.LineItems = unselectLineItems(auxStateTicket.LineItems);
  auxStateTicket.SmartLineItems = unselectLineItems(auxStateTicket.SmartLineItems);
  auxStateTicket.StraightM = unselectLineItems(auxStateTicket.StraightM);
  auxStateTicket.CombinationMulticast = unselectLineItems(auxStateTicket.CombinationMulticast);

  return {
    ...state,
    ticket: auxStateTicket,
  };
};

const setMultiStake = (state: ticketState, multiStake: StakeModel): ticketState => {
  const auxStateTicket = {
    ...state.ticket,
    LineItems: [...state.ticket.LineItems],
    SmartLineItems: [...state.ticket.SmartLineItems],
    StraightM: [...state.ticket.StraightM],
    CombinationMulticast: [...state.ticket.CombinationMulticast],
  } as TicketBetslipModel;
  auxStateTicket.processing = true;

  const updateAmount = (item, id) => {
    if (item?.ItemId === id) {
      return {
        ...item,
        Amount: multiStake.OverallStake / 100,
        AmountLocal: multiStake.OverallStake / 100,
      };
    }
    return item;
  };

  multiStake.ItemIds.forEach((id) => {
    auxStateTicket.LineItems = auxStateTicket.LineItems.map((item) => updateAmount(item, id));
    auxStateTicket.SmartLineItems = auxStateTicket.SmartLineItems.map((item) => updateAmount(item, id));
    auxStateTicket.StraightM = auxStateTicket.StraightM.map((item) => updateAmount(item, id));
    auxStateTicket.CombinationMulticast = auxStateTicket.CombinationMulticast.map((item) =>
      updateAmount(item, id),
    );
  });

  return {
    ...state,
    processingFrom: "setMultiStake",
    ticket: auxStateTicket,
  };
};

const setStake = (state: ticketState, stake: StakeModel): ticketState => {
  const auxStateTicket = { ...state.ticket, processing: true } as TicketBetslipModel;

  const updateLineItem = (lineItem) => {
    if (lineItem.ItemId === stake.ItemId) {
      return {
        ...lineItem,
        Amount: stake.OverallStake / 100,
        AmountLocal: stake.OverallStake / 100,
      };
    }
    return lineItem;
  };

  if (stake.ItemId) {
    auxStateTicket.LineItems = auxStateTicket.LineItems.map(updateLineItem);
    auxStateTicket.SmartLineItems = auxStateTicket.SmartLineItems.map(updateLineItem);
    auxStateTicket.StraightM = auxStateTicket.StraightM.map(updateLineItem);
    auxStateTicket.CombinationMulticast = auxStateTicket.CombinationMulticast.map(updateLineItem);
  } else if (stake.SystemId) {
    auxStateTicket.Total = stake.OverallStake / 100;
  }

  return {
    ...state,
    processingFrom: "setStake",
    ticket: auxStateTicket,
  };
};

const setSystemBetType = (
  state: ticketState,
  newTicketState: ticketState,
  systemStake: StakeModel,
): ticketState => {
  const auxState = { ...state };
  const auxStateTicket: TicketBetslipModel = { ...state.ticket } as TicketBetslipModel;
  auxState.betSlip = newTicketState.betSlip;

  auxStateTicket.StakeGroups = {
    ...auxStateTicket.StakeGroups,
    System: { ...auxStateTicket.StakeGroups.System },
  };

  const isAccumulator = systemStake.Group === StakeGroup.ACCUMULATOR;
  const possibleSystems = auxState.betSlip?.possibleSystems || [];
  const hasMultipleSystems = possibleSystems.length > 2;

  if (!isAccumulator && hasMultipleSystems) {
    const systems: systemData[] = _setPossibleSystems(auxState.betSlip);
    auxStateTicket.StakeGroups.System.possibleSystems = systems || [];

    let systemSelected = systems.find((system) => system.systemId === systemStake.SystemId);
    if (!systemSelected) {
      systemSelected = systems.find(
        (system) => system.systemType === StakeGroup.SYSTEM || system.systemType === StakeGroup.MULTI_WAY_SYSTEM,
      );
    }
    auxStateTicket.SystemSelected = systemSelected || null;

    if (systemSelected) {
      auxStateTicket.StakeGroups.System.systemId = systemSelected.systemId;
      auxStateTicket.StakeGroups.System.selectedGroup = systemSelected.groupName?.toLocaleLowerCase() ?? null;
      auxStateTicket.StakeGroups.System.totalAmount = systemStake.OverallStake / 100;
    } else {
      auxStateTicket.StakeGroups.System.systemId = null;
      auxStateTicket.StakeGroups.System.selectedGroup = null;
      auxStateTicket.StakeGroups.System.totalAmount = null;
    }
  } else if (possibleSystems.length < 3) {
    auxStateTicket.SystemSelected = null;
    auxStateTicket.StakeGroups.System.systemId = null;
    auxStateTicket.StakeGroups.System.selectedGroup = null;
    auxStateTicket.StakeGroups.System.totalAmount = null;
  }

  return {
    ...state,
    betSlip: auxState.betSlip,
    ticket: auxStateTicket,
  };
};

const ticketError = (state, error): ticketState => {
  console.error(error);

  aux.valueLineItems = undefined;
  aux.valueCombinationMulticast = undefined;
  aux.valueStraightM = undefined;
  aux.valueSmartLineItems = undefined;
  aux.modification = false;

  return {
    ...state,
    ticket: {
      ...state.ticket,
      isPlacingbet: false,
      processing: false,
    },
    processingFrom: "",
  };
};

const updateAndChangeToSingles = (state: ticketState, cuotaAccept: string, userLogged: boolean): ticketState => {
  const auxState = updateTicket(state, cuotaAccept, userLogged);
  const auxFilters = _setFilterStatus(auxState);

  return {
    ...state,
    filters: auxFilters.filters,
    filterSelected: auxFilters.filterSelected,
    ticket: auxFilters.ticket as TicketBetslipModel,
  };
};

const updateAndCheckForErrors = (state: ticketState, cuotaAccept: string, userLogged: boolean): ticketState => {
  const auxState = updateTicket(state, cuotaAccept, userLogged);
  const auxStateFilters = setFilters(auxState);
  const auxStateFilterSelected = setFilterSelected(auxStateFilters);

  return {
    ...state,
    filters: auxStateFilterSelected.filters,
    ticket: auxStateFilterSelected.ticket as TicketBetslipModel,
  };
};

const updateTicket = (state: ticketState, cuotaAccept, userLogged) => {
  const auxState = JSON.parse(JSON.stringify(state));
  if (auxState.betSlip === undefined || !auxState.betSlip) return state;
  const betSlipSingles = { ...auxState.betSlip.stakeGroups.singles };
  const betSlipAccumulator = { ...auxState.betSlip.stakeGroups.accumulator };
  const betSlipGroups = { ...auxState.betSlip.stakeGroups };
  const keepSelect = auxState.ticket.keepSelection;

  //set LineItems amounts
  auxState.ticket.LineItems.map((lineItem, index) => {
    if (
      auxState.betSlip.items.singleResultItems.find(
        (singleResultItem) => singleResultItem.resultId.toString() === lineItem.ResultsNr,
      )
    ) {
      auxState.ticket.LineItems[index].Odd = auxState.betSlip.items.singleResultItems.find(
        (singleResultItem) => singleResultItem.resultId.toString() === lineItem.ResultsNr,
      ).odds;
    }

    const existItemId = betSlipSingles?.staking?.singles.find((item) => item.itemId === lineItem.ItemId);

    if (!existItemId) {
      auxState.ticket.LineItems[index].Amount = 0;
      auxState.ticket.LineItems[index].AmountLocal = 0;
      auxState.ticket.LineItems[index].TotalPotentialWin = 0;
      auxState.ticket.StakeGroups.Singles.totalAmount = undefined;
      auxState.ticket.StakeGroups.Accumulator.totalAmount = undefined;
      auxState.ticket.StakeGroups.System.totalAmount = undefined;
    } else {
      betSlipSingles?.staking?.singles.map((item) => {
        if (lineItem.ItemId === item.itemId) {
          auxState.ticket.LineItems[index].Amount = item.overallStake / 100;
          auxState.ticket.LineItems[index].AmountLocal = item.overallStake / 100;
        }
      });
      betSlipSingles.calculation.singles.map((item) => {
        if (lineItem.ItemId === item.itemId) {
          auxState.ticket.LineItems[index].TotalPotentialWin = item.maxReturn / 100;
        }
      });
    }

    if (keepSelect) auxState.ticket.LineItems[index].TicketNumber = "";
  });
  //set SmartLineItems Amounts
  auxState.ticket.SmartLineItems.map((smartLineItem, index) => {
    if (
      auxState.betSlip.items.smartMarketItems.find(
        (smartMarketItem) => smartMarketItem.itemId === smartLineItem.ItemId,
      )
    ) {
      auxState.ticket.SmartLineItems[index].Odd = auxState.betSlip.items.smartMarketItems.find(
        (smartMarketItem) => smartMarketItem.itemId === smartLineItem.ItemId,
      ).odds;
    }

    const existItemId = betSlipSingles?.staking?.singles.find((item) => item.itemId === smartLineItem.ItemId);

    if (!existItemId) {
      auxState.ticket.SmartLineItems[index].Amount = 0;
      auxState.ticket.SmartLineItems[index].AmountLocal = 0;
      auxState.ticket.SmartLineItems[index].TotalPotentialWin = 0;
      auxState.ticket.StakeGroups.Singles.totalAmount = undefined;
      auxState.ticket.StakeGroups.Accumulator.totalAmount = undefined;
      auxState.ticket.StakeGroups.System.totalAmount = undefined;
    } else {
      betSlipSingles?.staking?.singles.map((item) => {
        if (smartLineItem.ItemId === item.itemId) {
          auxState.ticket.SmartLineItems[index].Amount = item.overallStake / 100;
          auxState.ticket.SmartLineItems[index].AmountLocal = item.overallStake / 100;
        }
      });
      betSlipSingles.calculation.singles.map((item) => {
        if (smartLineItem.ItemId === item.itemId) {
          auxState.ticket.SmartLineItems[index].TotalPotentialWin = item.maxReturn / 100;
        }
      });
    }
    if (keepSelect) auxState.ticket.SmartLineItems[index].TicketNumber = "";
  });
  //set StraightM Amounts
  auxState.ticket.StraightM.map((straightMulticastBet, index) => {
    const existItemId = betSlipSingles?.staking?.singles.find(
      (item) => item.itemId === straightMulticastBet.ItemId,
    );

    if (!existItemId) {
      auxState.ticket.StraightM[index].Amount = 0;
      auxState.ticket.StraightM[index].AmountLocal = 0;
      auxState.ticket.StraightM[index].TotalPotentialWin = 0;
      auxState.ticket.StakeGroups.Singles.totalAmount = undefined;
      auxState.ticket.StakeGroups.Accumulator.totalAmount = undefined;
      auxState.ticket.StakeGroups.System.totalAmount = undefined;
    } else {
      betSlipSingles?.staking?.singles.map((item) => {
        if (straightMulticastBet.ItemId === item.itemId) {
          auxState.ticket.StraightM[index].Amount = item.overallStake / 100;
          auxState.ticket.StraightM[index].AmountLocal = item.overallStake / 100;
        }
      });
      betSlipSingles.calculation.singles.map((item) => {
        if (straightMulticastBet.ItemId === item.itemId) {
          auxState.ticket.StraightM[index].TotalPotentialWin = item.maxReturn / 100;
        }
      });
    }
    if (keepSelect) auxState.ticket.StraightM[index].TicketNumber = "";
  });
  //set CombinationMulticast Amounts
  auxState.ticket.CombinationMulticast.map((combinationMulticastBet, index) => {
    const existItemId = betSlipSingles?.staking?.singles.find(
      (item) => item.itemId === combinationMulticastBet.ItemId,
    );

    if (!existItemId) {
      auxState.ticket.CombinationMulticast[index].Amount = 0;
      auxState.ticket.CombinationMulticast[index].AmountLocal = 0;
      auxState.ticket.CombinationMulticast[index].TotalPotentialWin = 0;
      auxState.ticket.StakeGroups.Singles.totalAmount = undefined;
      auxState.ticket.StakeGroups.Accumulator.totalAmount = undefined;
      auxState.ticket.StakeGroups.System.totalAmount = undefined;
    } else {
      betSlipSingles?.staking?.singles.map((item) => {
        if (combinationMulticastBet.ItemId === item.itemId) {
          auxState.ticket.CombinationMulticast[index].Amount = item.overallStake / 100;
          auxState.ticket.CombinationMulticast[index].AmountLocal = item.overallStake / 100;
        }
      });
      betSlipSingles.calculation.singles.map((item) => {
        if (combinationMulticastBet.ItemId === item.itemId) {
          auxState.ticket.CombinationMulticast[index].TotalPotentialWin = item.maxReturn / 100;
        }
      });
    }
    if (keepSelect) auxState.ticket.CombinationMulticast[index].TicketNumber = "";
  });

  auxState.ticket.TotalLocal = (betSlipSingles?.staking?.overallStake / 100).toString();

  //set StakeGroups and SystemSelected
  // Singles
  if (betSlipSingles.staking && betSlipSingles.calculation) {
    auxState.ticket.StakeGroups.Singles.totalAmount = betSlipSingles?.staking?.overallStake / 100;
    auxState.ticket.StakeGroups.Singles.totalPotentialWin =
      betSlipSingles.calculation.betslip.maxReturnNetIncludingBonus / 100;
  }

  // Accumulator
  if (betSlipAccumulator.staking && betSlipAccumulator.calculation) {
    if (betSlipAccumulator.staking.overallStake) {
      auxState.ticket.StakeGroups.Accumulator.totalAmount = betSlipAccumulator.staking.overallStake / 100;
    }
    if (betSlipAccumulator.calculation.betslip) {
      auxState.ticket.StakeGroups.Accumulator.totalPotentialWin =
        betSlipAccumulator.calculation.betslip.maxReturnNetIncludingBonus / 100;
    }
    if (
      betSlipAccumulator.calculation.systems.length > 0 &&
      betSlipAccumulator.calculation.systems[0].bonus.length > 0
    ) {
      auxState.ticket.ApplicableAccaBonus = AABonusMethods.mapBonus(
        betSlipAccumulator.calculation.systems[0].bonus[0],
      );
    } else {
      auxState.ticket.ApplicableAccaBonus = AABonusMethods.newApplicableAccaBonus();
    }
  }

  // System
  const filterSelected = auxState.filterSelected;
  const possibleSystems = auxState.betSlip.possibleSystems.filter(
    (i) => i.systemType !== StakeGroup.SINGLES && i.systemType !== StakeGroup.ACCUMULATOR,
  );
  if (
    betSlipGroups &&
    filterSelected !== undefined &&
    filterSelected !== null &&
    filterSelected.betType === StakeGroup.SYSTEM &&
    possibleSystems.length > 0
  ) {
    if (!auxState.ticket.SystemSelected)
      auxState.ticket.SystemSelected = auxState.ticket.StakeGroups.System.possibleSystems[0];
    const groupName = auxState.ticket.SystemSelected.groupName;
    switch (groupName) {
      case "Doubles":
        if (betSlipGroups.doubles) {
          if (betSlipGroups.doubles.staking && betSlipGroups.doubles.calculation) {
            if (betSlipGroups.doubles.staking.overallStake) {
              auxState.ticket.StakeGroups.System.totalAmount = betSlipGroups.doubles.staking.overallStake / 100;
            }
            if (betSlipGroups.doubles.calculation.betslip) {
              auxState.ticket.StakeGroups.System.totalPotentialWin =
                betSlipGroups.doubles.calculation.betslip.maxReturnNetIncludingBonus / 100;
            }
            auxState.ticket.StakeGroups.System.selectedGroup = "doubles";
            auxState.ticket.StakeGroups.System.systemId = 2;
          }
        }
        break;
      case "Triples":
        if (betSlipGroups.triples) {
          if (betSlipGroups.triples.staking && betSlipGroups.triples.calculation) {
            if (betSlipGroups.triples.staking.overallStake) {
              auxState.ticket.StakeGroups.System.totalAmount = betSlipGroups.triples.staking.overallStake / 100;
            }
            if (betSlipGroups.triples.calculation.betslip) {
              auxState.ticket.StakeGroups.System.totalPotentialWin =
                betSlipGroups.triples.calculation.betslip.maxReturnNetIncludingBonus / 100;
            }
            auxState.ticket.StakeGroups.System.selectedGroup = "triples";
            auxState.ticket.StakeGroups.System.systemId = 3;
          }
        }
        break;
      case "Cuadruples":
        if (betSlipGroups.cuadruples) {
          if (betSlipGroups.cuadruples.staking && betSlipGroups.cuadruples.calculation) {
            if (betSlipGroups.cuadruples.staking.overallStake) {
              auxState.ticket.StakeGroups.System.totalAmount = betSlipGroups.cuadruples.staking.overallStake / 100;
            }
            if (betSlipGroups.cuadruples.calculation.betslip) {
              auxState.ticket.StakeGroups.System.totalPotentialWin =
                betSlipGroups.cuadruples.calculation.betslip.maxReturnNetIncludingBonus / 100;
            }
            auxState.ticket.StakeGroups.System.selectedGroup = "cuadruples";
            auxState.ticket.StakeGroups.System.systemId = 4;
          }
        }
        break;
      default: {
        const systemX = `system${auxState.ticket.SystemSelected.systemId}`;
        if (betSlipGroups[systemX]) {
          if (betSlipGroups[systemX].staking && betSlipGroups[systemX].calculation) {
            if (betSlipGroups[systemX].staking.overallStake) {
              auxState.ticket.StakeGroups.System.totalAmount = betSlipGroups[systemX].staking.overallStake / 100;
            }
            if (betSlipGroups[systemX].calculation.betslip) {
              auxState.ticket.StakeGroups.System.totalPotentialWin =
                betSlipGroups[systemX].calculation.betslip.maxReturnNetIncludingBonus / 100;
            }
            auxState.ticket.StakeGroups.System.selectedGroup = systemX;
            auxState.ticket.StakeGroups.System.systemId = auxState.ticket.SystemSelected.systemId;
          }
        }
        break;
      }
    }
  }
  auxState.ticket.processing = false;
  const newStateTicket = _ticketHasOddsChanges(auxState.ticket, cuotaAccept, userLogged);
  const newState: ticketState = Object.assign({}, state, {
    ticket: newStateTicket as TicketBetslipModel,
  });
  return newState;
};

// UTILS
const _ticketHasOddsChanges = (
  ticket: TicketBetslipModel,
  cuotaAccept: string,
  userLogged,
): TicketBetslipModel => {
  ticket = _gameChangedQuote(ticket);

  const oddAcceptance = cuotaAccept;
  const keys = Object.keys(ticket.OrderErrors);
  const isOddChangeError = keys.includes("51937");

  if (!userLogged || oddAcceptance === "0" || !isOddChangeError) {
    ticket.hasChangesInOdds = false;
    if (Object.keys(ticket.OrderErrors).length !== 0) TicketMethods.deleteError(ticket, "51937");
    return ticket;
  }

  const cond =
    oddAcceptance === "1"
      ? (item) => item.downOdd
      : oddAcceptance === "2"
        ? (item) => item.downOdd || item.upOdd
        : () => false;

  ticket.hasChangesInOdds = ticket.LineItems.some(cond);

  if (
    (oddAcceptance === "1" && isOddChangeError) ||
    (oddAcceptance === "2" && ticket.hasChangesInOdds && isOddChangeError)
  ) {
    if (Object.keys(ticket.OrderErrors).length !== 0) TicketMethods.deleteError(ticket, "51937");
    return ticket;
  }

  return ticket;
};

const _ticketCheckErrors = (newState: ticketState): TicketBetslipModel => {
  let { betSlip, filterSelected, ticket } = newState;

  const existAccumulator = betSlip?.possibleSystems.some((system) => system.systemType === StakeGroup.ACCUMULATOR);
  const existMultiples = betSlip?.possibleSystems.some(
    (system) => system.systemType === StakeGroup.SYSTEM || system.systemType === StakeGroup.MULTI_WAY_SYSTEM,
  );

  const addError = (error: { code: string; message: string }) => {
    ticket = {
      ...ticket,
      OrderErrors: {
        ...(typeof ticket.OrderErrors === "object" && ticket.OrderErrors !== null ? ticket.OrderErrors : {}),
        [error.code]: error.message,
      },
      OrderErrorMessages: ticket.OrderErrorMessages.includes(error.message)
        ? ticket.OrderErrorMessages
        : [...ticket.OrderErrorMessages, error.message],
    };
  };

  const removeError = (errorKey: string) => {
    if (ticket.OrderErrors[errorKey]) {
      const error = ticket?.OrderErrors[errorKey];
      if (!error) {
        return;
      }
      ticket = {
        ...ticket,
        OrderErrorMessages: ticket.OrderErrorMessages.filter((e) => e.toLowerCase() !== error.toLowerCase()),
        OrderErrors: Object.keys(ticket.OrderErrors).reduce((acc, key) => {
          if (key !== errorKey) {
            acc[key] = ticket.OrderErrors[key];
          }
          return acc;
        }, {}),
      };
    }
  };

  if (filterSelected?.value === 2 && !existMultiples) {
    addError(ticketErrorConstants.multiError);
  } else {
    removeError("multiError");
  }

  if (filterSelected?.value === 1 && !existAccumulator) {
    addError(ticketErrorConstants.code_51931);
  } else {
    removeError(ticketErrorConstants.code_51931.code);
  }

  const gameLocked = TicketMethods.getAllItems(ticket).some((item) => item.GameLocked);
  if (gameLocked) {
    addError(ticketErrorConstants.code_51941);
  } else {
    removeError(ticketErrorConstants.code_51941.code);
  }

  const gameEnded = TicketMethods.getAllItems(ticket).some((item) => item.NotAvailable);
  if (gameEnded) {
    addError(ticketErrorConstants.code_51927);
  } else {
    removeError(ticketErrorConstants.code_51927.code);
  }

  const toLowMinAmountPerWay = TicketMethods.getAllItems(ticket).some((item) => item.NotAvailable);
  if (toLowMinAmountPerWay) {
    addError(ticketErrorConstants.ST_BS_ToLowMinAmountPerWay);
  } else {
    removeError(ticketErrorConstants.ST_BS_ToLowMinAmountPerWay.code);
  }

  if (filterSelected?.value !== 1) {
    removeError(ticketErrorConstants.NationalBetError.code);
  }

  return ticket;
};

const _checkOddsChangeErrors = (ticket: TicketBetslipModel, errorCode: string): TicketBetslipModel => {
  const keys = Object.keys(ticket.OrderErrors);
  const isOddChangeError = keys.some((key) => key.includes("ST_EMS_ErrorOdds"));

  const isOddsChangeUp = errorCode === ticketErrorConstants.ST_EMS_ErrorOddsChangeUp.code;
  const isOddsChangeDown = errorCode === ticketErrorConstants.ST_EMS_ErrorOddsChangeDown.code;
  const isInvalidOdd = errorCode === ticketErrorConstants.ST_SBS_CalculationBaseInvalidOdd.code;

  ticket.hasChangesInOdds = isOddsChangeUp || isOddsChangeDown || isInvalidOdd;

  if (ticket.hasChangesInOdds && isOddChangeError) {
    if (Object.keys(ticket.OrderErrors).length !== 0) {
      TicketMethods.deleteError(ticket, errorCode);
    }
  }

  return ticket;
};

const _checkSmartLineItemMarketErrors = (
  ticket: TicketBetslipModel,
  singleTicketItem: CloseTicketItem,
): TicketBetslipModel => {
  const errorCodes = singleTicketItem.ErrorCode;
  const notActiveMsg = ticketErrorConstants.ST_SBS_EventNodeNotActive.message;
  const notActiveCode = ticketErrorConstants.ST_SBS_EventNodeNotActive.code;

  if (Array.isArray(errorCodes) && errorCodes.includes(notActiveMsg)) {
    ticket.SmartLineItems = ticket.SmartLineItems.map((smartLineItem) =>
      smartLineItem.ItemId === singleTicketItem.ItemId ? { ...smartLineItem, NotAvailable: true } : smartLineItem,
    );
  }

  if (ticket.OrderErrors[notActiveCode]) {
    ticket.OrderErrorMessages = [notActiveMsg];
  }

  return ticket;
};

const _setFilterStatus = (state: ticketState): ticketState => {
  const auxState: ticketState = { ...state };
  const filters: BetslipFilterItem[] = auxState.filters.map((filter) => ({ ...filter }));
  const filterSelected: BetslipFilterItem = auxState.filterSelected;
  let existMultiples = false;

  if (auxState.betSlip && Array.isArray(auxState.betSlip.possibleSystems)) {
    existMultiples = auxState.betSlip.possibleSystems.some(
      (system) => system.systemType === StakeGroup.SYSTEM || system.systemType === StakeGroup.MULTI_WAY_SYSTEM,
    );
  }

  const numberOfSelections = TicketMethods.getNumberOfSelections(auxState.ticket);
  let auxFilterSelected = { ...filterSelected };

  filters.forEach((filter) => {
    filter.selected = false;
    filter.disabled = false;
  });

  if (numberOfSelections < 1) {
    filters[0].selected = true;
    filters[1].disabled = true;
    filters[2].disabled = true;
  } else if (numberOfSelections === 1) {
    filters[0].selected = true;
    filters[1].disabled = true;
    filters[2].disabled = true;
    if (filterSelected !== null && filterSelected.value === 1) {
      auxFilterSelected = filters[0];
    }
  } else {
    filters[1].disabled = false;
    filters[2].disabled = !existMultiples;
    if (!existMultiples && filters[2].selected) {
      filters[0].selected = true;
      filters[2].selected = false;
    }
  }

  return {
    ...state,
    filters,
    filterSelected: auxFilterSelected,
  };
};

const _setPossibleSystems = (betSlip: BetslipProviderModel): systemData[] => {
  const possibleSystems: systemData[] = [];
  betSlip.possibleSystems.map((system) => {
    if (system.systemType === StakeGroup.SYSTEM || system.systemType === StakeGroup.MULTI_WAY_SYSTEM) {
      let text = "";
      let groupName = "";
      switch (system.systemId) {
        case 2:
          text = `Dobles: ${system.numberOfBetWays} apuestas`;
          groupName = StakeGroup.DOUBLES;
          break;
        case 3:
          text = `Triple: ${system.numberOfBetWays} apuestas`;
          groupName = StakeGroup.TRIPLES;
          break;
        case 4:
          text = `Cuadruple: ${system.numberOfBetWays} apuestas`;
          groupName = StakeGroup.CUADRUPLES;
          break;
        default:
          text = `Multiple (${system.systemId}): ${system.numberOfBetWays} apuestas`;
          groupName = `${StakeGroup.SYSTEM}${system.systemId}`;
          break;
      }
      const possibleSystem: systemData = {
        canBeEachWay: false,
        numberOfBetWays: system.numberOfBetWays,
        numberOfEachWayBetWays: system.numberOfEachWayBetWays,
        systemId: system.systemId,
        systemType: system.systemType,
        text: text,
        groupName: groupName,
      };
      possibleSystems.push(possibleSystem);
    }
  });
  return possibleSystems;
};

const _gameChangedQuote = (ticket): TicketBetslipModel => {
  // Verifica si hay cambios de cuota en los line items y agrega/elimina el mensaje de error correspondiente
  const hasQuoteChange = TicketMethods.getAllItems(ticket).some((item) => item.downOdd || item.upOdd);

  if (hasQuoteChange) {
    ticket.OrderErrors[ticketErrorConstants.code_51937.code] = ticketErrorConstants.code_51937.message;
    if (!ticket.OrderErrorMessages.some((msg) => msg.includes(ticketErrorConstants.code_51937.message))) {
      ticket.OrderErrorMessages.push(ticketErrorConstants.code_51937.message);
    }
  } else {
    if (Object.keys(ticket.OrderErrors).length !== 0) {
      TicketMethods.deleteError(ticket, ticketErrorConstants.code_51937.code);
    }
  }

  return ticket;
};

const closeBetNewOds = (lineItems, newOdd) => {
  const newLineItems = lineItems.map((lineItem) => {
    const updatedLineItem = { ...lineItem };
    const newOddItem = newOdd.find((item) => item.ResultId === lineItem.ResultsNr);
    if (newOddItem) {
      updatedLineItem.upOdd = newOddItem.Odd > lineItem.Odd;
      updatedLineItem.downOdd = newOddItem.Odd < lineItem.Odd;
      updatedLineItem.Odd = newOddItem.Odd;
    }
    return updatedLineItem;
  });
  return newLineItems;
};
